import {Theme} from "./ThemeContext";

export default class ThemeFactory {

    static tableVersion : boolean = false

    static withDirectory(directory : string) : Theme {
        return {
            tableVersion : ThemeFactory.tableVersion,
            homeTopImage : "images/" + directory + "/home-top.png",
            backgroundImage : "images/" + directory + "/background.png",
            diplomaImage : "images/" + directory + "/diploma.png",
            helperImage : "images/" + directory + "/helper.png",
        }
    }

    static empty() {
        return {
            tableVersion : ThemeFactory.tableVersion,
            homeTopImage : "images/shared/home-top.png",
            backgroundImage : null,
            diplomaImage : null,
            helperImage : null,
        }
    }
}